import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["src", "width", "height"]
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  key: 1,
  class: "fs11"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 3,
  class: "posAb circleBlueButton whiteColor fw600",
  style: {"top":"2px","right":"2px","background":"#69d54f"}
}
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserFileImage = _resolveComponent("UserFileImage")!

  return (_ctx.file)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "posRe",
        onMouseover: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.showChangeImage && _ctx.showChangeImage(...args))),
        onMouseleave: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hideChangeImage && _ctx.hideChangeImage(...args)))
      }, [
        (_ctx.file.is_image_file)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.file.image_url,
              width: _ctx.width,
              height: _ctx.width,
              class: "fl",
              style: {"object-fit":"cover"}
            }, null, 8, _hoisted_1))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              style: _normalizeStyle(`width:${_ctx.width}px;height:${_ctx.width}px;padding-top:20px;object-fit: cover`),
              class: "centered pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
            }, [
              (_ctx.canDelete)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "posAb",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.deleteImage && _ctx.deleteImage(...args))),
                    style: {"right":"3px","top":"3px"}
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                      width: "16",
                      height: "18"
                    }, null, 8, _hoisted_2)
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_UserFileImage, {
                file: _ctx.file,
                showDeleteButton: false,
                type: `square`,
                hideToolTip: true,
                hideDownloadLink: true,
                class: "",
                onDeleted: _ctx.deleteImage
              }, null, 8, ["file", "onDeleted"]),
              _hoisted_3,
              (_ctx.file.original_filename)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.truncate(_ctx.file.original_filename, 15)) + _toDisplayString(`(${_ctx.file.file_size})`), 1))
                : _createCommentVNode("", true)
            ], 4)),
        (_ctx.mouseoverImage)
          ? (_openBlock(), _createElementBlock("label", {
              key: 2,
              class: "ChangeImageIcon centered pointer blackBg posAb",
              style: _normalizeStyle(`left:0;top:0;opacity: 0.8; height: ${_ctx.width}px; width: ${_ctx.width}px;`),
              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)), ["self"]))
            }, [
              (_ctx.canDelete)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "posAb",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.deleteImage && _ctx.deleteImage(...args))),
                    style: {"right":"3px","top":"3px"}
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/trash_wt.png`),
                      width: "16",
                      height: "18"
                    }, null, 8, _hoisted_5)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", {
                class: _normalizeClass(`fs14 centered mt5 fw600 whiteColor`),
                style: _normalizeStyle(`line-height:${_ctx.width}px;`),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
              }, [
                _createElementVNode("img", {
                  src: _ctx.$getAssetImageUrl(`/assets/icons/refresh_wt.png`),
                  width: "24",
                  height: "24"
                }, null, 8, _hoisted_6)
              ], 4)
            ], 4))
          : _createCommentVNode("", true),
        (_ctx.selected)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("img", {
                src: _ctx.$getAssetImageUrl(`/assets/icons/check_wt.png`),
                width: "17",
                height: "17",
                style: {"margin-top":"-2px"}
              }, null, 8, _hoisted_8)
            ]))
          : _createCommentVNode("", true)
      ], 32))
    : _createCommentVNode("", true)
}